import React from 'react';
import Link from '../components/Link';
import BlockContent from '@sanity/block-content-to-react';
import format from 'date-fns/format';

export default ({
	author = {},
	date,
	title,
	subtitle,
	reviewer = '',
	factChecker = '',
}) => {
	return (
		<div className="postContent-wrapper">
    <h1>{title}</h1>
    {subtitle?.trim() && <h3 className="postHeading-h3">{subtitle}</h3>}
    <div className="author-details">
        <div className="avatar">
            <picture>
			<img 
				src={author.image?.url || '/images/user.png'} 
				alt={author.image?.alt || author.name} 
			/>
            </picture>
        </div>
        <div className="dib rich-text author-div">
            <p className="mt0 mb0">
               Written by: <br/>
			   <strong><Link aria-label={author.name} url={`/blog/author/${author.slug}`} style={{borderBottom: 'none'}}>
                {author.name}
                </Link></strong>
                {/* <span> on {format(new Date(date), 'MMMM d, yyyy')}</span> */}
            </p>
        </div>
    </div>
    <p className='post-para'></p>
    {/* partial:index.partial.html */}
    <div class="table-content">
        <div class="table-content-inner">
            <h3>Table of contents:</h3>

            <ul>
                <li>&nbsp;</li>
            </ul>
        </div>
    </div>
    {/* partial */}
</div>

	);
};
